import { format } from 'date-fns';
import Link from 'gatsby-link';
import React, { Component } from 'react';
import styled from 'styled-components';

import TopLevelLayout from '../components/Layout/TopLevelLayout';
import SEO from '../components/SEO/SEO';
import MainHeader from '../components/Layout/Header';
import MainFooter from '../components/Layout/Footer';
import ValuePropContainer from '../components/Layout/ValuePropContainer.div';
import { H3, H5 } from '../components/Type/Display.h';
import P from '../components/Type/Paragraph.p';
import HorizontalRule from '../components/Layout/HorizontalRule.hr';
import { Button } from '../components/Inputs/Button.span';
import trackPageView from '../components/analytics/trackPageView';
import { LANDING_PAGE } from '../components/analytics/contentGroups';

const HeroWithHeader = styled.div`
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
  background-size: cover;
  @media screen and (max-width: 45em) {
    background-position: top 0 right -240px;
  }
  & > .hero {
    padding: 3em 4em 10em;
    & > div {
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      margin: 0 auto;
      max-width: 920px;
      padding: 3em 2em;
      box-shadow: 0 5px 32px -5px rgba(0, 0, 0, .25);
      border-radius: 6px;
      .text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: left;
        padding: 0;
        h2, h5 {
          margin-top: 0.5em;
        }
        hr {
          opacity: 0.2;
        }
        p > a {
          text-decoration: underline;
        }
        & > a {
          padding: 1.5em 0 0.5em;
          &, button {
            margin: inherit;
          }
        }
      }
      @media screen and (max-width: 45em) {
        width: 100%;
        max-width: 100%;
        flex-direction: column;
        padding: 2em 1em;
        .text {
          padding: 0;
          margin: 0;
          margin-bottom: 1em;
        }
      }
    }
    @media screen and (max-width: 45em) {
      padding: 1em 1em 8em;
    }
  }
`;

export default class FurloughPage extends Component {
  componentDidMount() {
    trackPageView(LANDING_PAGE);
  }

  render() {
    return (
      <TopLevelLayout>
        <div>
          <SEO
            title="Furloughed Financial Assistance - Chapter 7 Bankruptcy | Upsolve"
            description={`Free bankruptcy help for furloughed federal employees dealing with overwhelming housing, food, medical, and credit card debt.`}
            image="https://upsolve.org/images/meta-probono.png"
          />
          <HeroWithHeader>
            <MainHeader className="header" />
            <main className="hero">
              <div>
                <div className="text">
                  <H3 as="h1">Free Bankruptcy Assistance &ndash; Furloughed Federal Employees</H3>
                  <a href="https://my.upsolve.org/screener">
                    <Button buttonType="white">Get Bankruptcy Help</Button>
                  </a>
                  <HorizontalRule />
                  <H5 as="h2">Bankruptcy might be an option if you have compounding debts due to housing insecurity, medical bills, credit cards, or other costs.</H5>
                  <P>As we see the shutdown continue, we continue to hear stories of civil servants who have risked comfort, savings, and themselves to serve the country. We have heard about the inability to pay rent, visits to food banks, restructuring of student-debts, and new searches for work.</P>
                  <P>Bankruptcy was developed as a backstop when all other systems have failed a person. When the circumstances surrounding them have not given them the chance to succeed. It is sad that the system that has failed thousands of civil servants is within control.</P>
                  <P>We are available to help any federal employees who have fallen into financial despair because they do not have the communal or financial support networks needed to get through this government shutdown.</P>
                  <P>If you or someone you know is being crushed by compounding credit card or medical debt, please get in touch with us at <a href="mailto:help@upsolve.org?subject=Furlough">help@upsolve.org</a>. You can read about the <Link to="/learn/pros-cons-filing-chapter-7-bankruptcy/">effects and benefits of chapter 7 bankruptcy here</Link>. We are here for you.</P>
                  <a href="mailto:help@upsolve.org?subject=Furlough">
                    <Button size="lg" buttonType="white">Get in Touch</Button>
                  </a>
                </div>
              </div>
            </main>
          </HeroWithHeader>

          <ValuePropContainer />
          <MainFooter />
        </div>
      </TopLevelLayout>
    );
  }
}
